import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from './styles/global-styles';
import theme from './styles/theme';
import Layout from './components/layout/layout';
import HomePage from './pages/home-page';
import AboutPage from './pages/about-page';
import HowItWorksPage from './pages/how-it-works-page';
import PricingPage from './pages/pricing-page';
import ContactPage from './pages/contact-page';
import WaitlistPage from './pages/waitlist-page';
import FeaturesPage from './pages/features-page';
import AdminPage from './pages/admin-page';
import PrivacyPolicyPage from './pages/privacy-policy-page';
import TermsOfServicePage from './pages/terms-of-service-page';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/waitlist" element={<WaitlistPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
};

export default App;
